import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { makePointer } from '../../../api/_utils'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'
import { computeOptions } from '../utils/computeData'
import { useUserFormContext } from '../utils/userFormContext'
import { useGetIdsReferencesSpecialities } from '@toktokdoctech/tokapi-client'

const Speciality = () => {
    const { control, setValue, watch, trigger } = useFormContextUser()
    const professionId = watch('professionId')
    const speciality = watch('speciality')
    const { state } = useUserFormContext()

    const validRpps = watch('validRpps')

    const { data } = useGetIdsReferencesSpecialities(
        {
            professionId,
        },
        {
            query: {
                enabled: Boolean(professionId),
            },
        },
    )

    const handleChange = (speciality: string) => {
        const selectedSpeciality = data?.find((el) => el?.name === speciality)

        const specialityId = selectedSpeciality?.id ?? ''
        const specialityName = selectedSpeciality?.name ?? ''

        const specialityPointer = makePointer('Speciality', specialityId)

        setValue('specialityPointer', specialityPointer, { shouldValidate: true })
        setValue('speciality', specialityName, { shouldValidate: true })
        setValue('specialityId', specialityId, { shouldValidate: true })
    }

    const relatedSpecialities = React.useMemo(() => {
        if (data) {
            const specialities = computeOptions(data)
            return specialities
        }
        return []
    }, [data, professionId])

    useEffect(() => {
        if (professionId && relatedSpecialities) {
            trigger(['speciality', 'specialityPointer'])
        }
    }, [professionId, trigger, relatedSpecialities, setValue, speciality])

    return (
        <Controller
            control={control}
            name="speciality"
            rules={{
                validate: (val) => {
                    if (relatedSpecialities.length === 0) return true
                    const isMatch = relatedSpecialities.some((spec) => spec.value === val) || !val
                    return isMatch || 'La spécialité ne correspond pas à la profession sélectionnée'
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="select"
                    label="Spécialité"
                    type="default"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value) || (!field.value && validRpps),
                    }}
                    disabled={!professionId}
                    locked={state.rppsLocked}
                    readonly={state.rppsLocked}
                    placeholder="Specialité"
                    value={field.value || undefined}
                    noValueText="Aucune spécialité"
                    onChange={(e) => {
                        if (e) {
                            handleChange(e)
                        }
                    }}
                    options={relatedSpecialities}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Speciality
